<template>
  <MiniCalendarLoading />
  <router-view></router-view>
</template>

<script>

import MiniCalendarLoading from './components/mini-calendar-loading.vue'

export default {
  name: 'App',
  components: {
    MiniCalendarLoading
  }
}
</script>

<style lang="scss">
  @import "./assets/scss/app.scss";

  .mini-calendar {

    &-title {
      color: $text-color2;
    }

    &-banner {
      background-color: $background-color3;
      padding: rem(30) 0 rem(30);
      margin-bottom: rem(30);
    }
  }
</style>
